import safeStateChanger from "./SafeStateChanger";

// todo, migrate usages of safeStateChanger to this class
class Changer {
  changeImmutable(object, property, value) {
    return safeStateChanger.changeValue(object, property, value);
  }
}
const changer = new Changer();
export default changer;